export default __webpack_public_path__ + "static/media/suggestedSheet.146df55b.svg";